import { createContext, useContext } from "react";

// Types
import { OnboardingContextType } from "./types";

const DefaultOnboardingContext: OnboardingContextType = {
  currentSection: 'learning_preferences',
  onNextSection: () => {},
  onPreviousSection: () => {},
  setShowBackground: () => {},
  setOnboardingData: () => {},
  onFinishOnboarding: () => {},
}

export const OnboardingContext = createContext<OnboardingContextType>(DefaultOnboardingContext);
export const OnboardingProvider = OnboardingContext.Provider;
export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboardingContext must be used within an OnboardingProvider');
  }
  return context;
}
